import { render, staticRenderFns } from "./OnboardingV2.vue?vue&type=template&id=7b233dbc&scoped=true"
import script from "./OnboardingV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OnboardingV2.vue?vue&type=style&index=0&id=7b233dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_supports-color@7.2.0__css_4ebb8a9bdd1166ae2f68e8a453c2f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b233dbc",
  null
  
)

export default component.exports